import { ClassOutput, SerieOutput } from '@/api/gql/graphql';
import { MenuDropdown } from '@/components/Common';
import { useLessons } from './lessons.hook';
import { ListItem } from '@/components/Ui';
import { useModuleStore } from '@/store/ModuleStore/ModuleStore';
import { useModule } from './module/module.hook';
import { AlertModal } from '@/components/Layout/AlertModal/AlertModal';

const LessonsList = () => {
  const {
    filteredLessons,
    loadingLessons,
    menuItems,
    setLessonId,
    lessonId,
    isModalConfirmationLessonOpen,
    setIsModalConfirmationLessonOpen,
    isCreatePending,
    isUpdatePending,
    handleConfirmLessonAction,
    lesson,
  } = useLessons();
  const {
    sectionsData,
    openLessonId,
    handleLessonClick,
    menuItemsModule,
    isDeleteModalOpen,
    setIsDeleteModalOpen,
    handleConfirmDelete,
    isRemoveQuestionPending,
    isModalConfirmationOpen,
    setIsModalConfirmationOpen,
    handleConfirmAction,
    modalTitle,
    modalMessage,
    buttonTitle,
  } = useModule();

  const { setModuleId } = useModuleStore();

  return (
    <>
      <div className="flex flex-col overflow-auto mb-6 pl-2">
        {filteredLessons?.length ? (
          filteredLessons?.map((lesson) => {
            return (
              <div key={lesson._id}>
                <ListItem
                  onClick={() => handleLessonClick(lesson._id)}
                  connector
                  listItemStyle={`!bg-black !hover:border-l-[#FEC200] ${lesson?._id === openLessonId ? '!border-l-[#FEC200]' : ''}`}
                  isActive={lesson._id === lessonId}
                  isOpen={lesson._id === openLessonId}
                  focused={lesson?.isPublished === true}
                  leftBorderColor={lesson?.isPublished ? '#FFF' : '#616163'}
                  subItems={
                    lesson._id === lessonId && sectionsData
                      ? sectionsData.map((section) => ({
                          connector: true,
                          leftBorderColor:
                            section?.isPublished === true ? '#FFF' : '#616163',
                          children: (
                            <div className="flex justify-between items-center text-white">
                              <div className="flex items-center">
                                <p>Module {section.position} :</p>
                                <p className="text-white ml-1">
                                  {section.title}
                                </p>
                              </div>
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setModuleId(section._id);
                                }}
                              >
                                <MenuDropdown
                                  menuItems={menuItemsModule(section)}
                                  dotsStyle="bg-black"
                                />
                              </div>
                            </div>
                          ),
                        }))
                      : undefined
                  }
                >
                  <div className="flex justify-between">
                    <div className="flex flex-col">
                      <h3 className="text-[15.478px] not-italic font-bold pb-2 leading-[16.509px]">
                        {lesson.name}
                      </h3>
                      <p className="text-[13.414px] not-italic font-normal leading-[16.509px] text-[#616163]">
                        {lesson.classes?.map(
                          (classe: ClassOutput, index: number) => (
                            <span key={classe._id}>
                              {index > 0 && ','} {classe.name}
                            </span>
                          ),
                        )}{' '}
                        (
                        {lesson.series?.map(
                          (serie: SerieOutput, index: number) => (
                            <span key={serie._id}>
                              {index > 0 && '-'}
                              {serie.name}
                            </span>
                          ),
                        )}
                        )
                      </p>
                    </div>
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        setLessonId(lesson._id);
                      }}
                    >
                      <MenuDropdown
                        menuItems={menuItems}
                        dotsStyle="bg-[#FEC20033]"
                      />
                    </div>
                  </div>
                </ListItem>
              </div>
            );
          })
        ) : (
          <div className="text-white h-10 flex items-center justify-center pt-4">
            {!loadingLessons && <span>Pas encore de leçon(s)</span>}
          </div>
        )}
      </div>

      <AlertModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        title="Confirmation de suppression"
        message="Êtes-vous sûr de vouloir supprimer ce module ? Cette action est irréversible."
        buttonTitle={
          isRemoveQuestionPending ? 'Suppression en cours...' : 'Supprimer'
        }
        buttonCancelTitle="Annuler"
        handleConfirm={handleConfirmDelete}
      />

      <AlertModal
        title={modalTitle}
        message={modalMessage}
        buttonTitle={buttonTitle}
        buttonCancelTitle="Non"
        handleConfirm={handleConfirmAction}
        isOpen={isModalConfirmationOpen}
        onClose={() => setIsModalConfirmationOpen(false)}
      />

      <AlertModal
        isOpen={isModalConfirmationLessonOpen}
        onClose={() => setIsModalConfirmationLessonOpen(false)}
        title={
          lesson?.isPublished
            ? 'Confirmation de cachage'
            : 'Confirmation de publication'
        }
        message={
          lesson?.isPublished
            ? 'Valider le cachage ?'
            : 'Valider la publication ?'
        }
        buttonTitle={isCreatePending || isUpdatePending ? 'Publier...' : 'Oui'}
        buttonCancelTitle="Non"
        handleConfirm={handleConfirmLessonAction}
      />
    </>
  );
};

export default LessonsList;
